import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {animate, state, style, transition, trigger} from '@angular/animations';
import {HttpClient} from '@angular/common/http';
import {of} from 'rxjs/internal/observable/of';
import {Subscription} from 'rxjs';
import {ConsuntivoUploadService} from '../../monthly-actual/consuntivo-upload/service-consuntivo-upload/consuntivo-upload.service';
import * as toastr from 'toastr';
import {MonthlyChargesUploadService} from '../../monthly-charges/monthly-charges-upload/service-changes-upload/monthly-charges-upload.service';
import { ProviderModel } from 'src/models/ProviderModel';

@Component({
  selector: 'app-material-file-upload',
  templateUrl: './material-file-upload.component.html',
  styleUrls: ['./material-file-upload.component.scss'],
  animations: [
    trigger('fadeInOut', [
      state('in', style({ opacity: 100 })),
      transition('* => void', [
        animate(300, style({ opacity: 0 }))
      ])
    ])
  ]
})
export class MaterialFileUploadComponent implements OnInit {

  /** Link text */
  @Input() text = 'Upload file';
  /** Name used in form which will be sent in HTTP request. */
  @Input() param = 'file';
  /** File extension that accepted, same as 'accept' of <input type="file" />.
   By the default, it's set to 'image/*'. */
  @Input() accept = '.csv';
  /** Allow you to add handler after its completion. Bubble up response text from remote. */
  @Output() complete = new EventEmitter<string>();

  files: Array<FileUploadModel> = [];
  consuntivoSubscribe: Subscription;

  private $event: any;
  @Input() numAnnoMese?: any;
  @Input() provider?: ProviderModel;
  @Input() status?: string;
  @Input() uploadType?: string;

  constructor(private _http: HttpClient,
              private consuntivoUpload: ConsuntivoUploadService,
              private serviceChangesUpload: MonthlyChargesUploadService) {
  }

  ngOnInit() {
  }

  onClick() {
    const fileUpload = document.getElementById('fileUpload') as HTMLInputElement;
    fileUpload.onchange = () => {
      for (let index = 0; index < fileUpload.files.length; index++) {
        const file = fileUpload.files[index];
        this.files.push({ data: file, state: 'in',
          inProgress: false, progress: 0, canRetry: false, canCancel: true });
      }
      this.uploadFiles();
    };
    fileUpload.click();
  }

  cancelFile(file: FileUploadModel) {
    this.consuntivoSubscribe.unsubscribe();
    this.removeFileFromArray(file);
  }

  retryFile(file: FileUploadModel) {
    this.uploadFile(file);
    file.canRetry = false;
  }

  private uploadFile(file: FileUploadModel) {
    const fd = new FormData();
    const fileName = file.data.name;
    fd.append(this.param, file.data);

    if (this.uploadType === 'consuntivo') {
      this.consuntivoSubscribe =
        this.consuntivoUpload.uploadConsumptive(fd, this.numAnnoMese, this.provider.cod, this.status)
        .subscribe(
          (event: any) => {
            if (event) {
              toastr.success('File:"' + fileName +'" uploaded with success', 'Success');
              this.removeFileFromArray(file);
              this.complete.emit(event.body);
            }
            if (!event) {
              toastr.success('File:"' + fileName +'" uploaded, check in Waste', 'Success');
              this.removeFileFromArray(file);
              this.complete.emit(event.body);
            }
          }, error => {
            toastr.warning('File:"' + fileName +'" not uploaded, contact the Administrator', 'Fatal Error');
            file.inProgress = false;
            file.canRetry = true;
            return of(`${file.data.name} upload failed.`);
          }
        );
    } else if (this.uploadType === 'monthly-charges') {
      this.consuntivoSubscribe =
        this.serviceChangesUpload.uploadMonthlyCharges(fd, this.numAnnoMese, this.provider.cod, this.status)
        .subscribe(
          (event: any) => {
            if (event) {
              this.removeFileFromArray(file);
              this.complete.emit(event.body);
              toastr.success('File:"' + fileName +'" uploaded with success', 'Success');
            }
            if (!event) {
              this.removeFileFromArray(file);
              this.complete.emit(event.body);
              toastr.success('File:"' + fileName +'" uploaded, check in Waste', 'Success');
            }
          }, error => {
            toastr.warning('File:"' + fileName +'" not uploaded, contact the Administrator', 'Fatal Error');
            file.inProgress = false;
            file.canRetry = true;
            return of(`${file.data.name} upload failed.`);
          }
        );
    }

  }

  private uploadFiles() {
    const fileUpload = document.getElementById('fileUpload') as HTMLInputElement;
    fileUpload.value = '';

    this.files.forEach(file => {
      this.uploadFile(file);
    });
  }

  private removeFileFromArray(file: FileUploadModel) {
    const index = this.files.indexOf(file);
    if (index > -1) {
      this.files.splice(index, 1);
    }
  }

}

export class FileUploadModel {
  data: File;
  state: string;
  inProgress: boolean;
  progress: number;
  canRetry: boolean;
  canCancel: boolean;
  sub?: Subscription;
}
